/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
    HTTPValidationError,
    ListProjectAdminResponse,
    ListProjectResponse,
    ProjectAdminModel,
    ProjectCreateModel,
    ProjectModel,
    ProjectUpdateModel,
    ResponseGetProjectApiV1ProjectsProjectGet,
    Search,
    Type,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ListProjectAdminResponseFromJSON,
    ListProjectAdminResponseToJSON,
    ListProjectResponseFromJSON,
    ListProjectResponseToJSON,
    ProjectAdminModelFromJSON,
    ProjectAdminModelToJSON,
    ProjectCreateModelFromJSON,
    ProjectCreateModelToJSON,
    ProjectModelFromJSON,
    ProjectModelToJSON,
    ProjectUpdateModelFromJSON,
    ProjectUpdateModelToJSON,
    ResponseGetProjectApiV1ProjectsProjectGetFromJSON,
    ResponseGetProjectApiV1ProjectsProjectGetToJSON,
    SearchFromJSON,
    SearchToJSON,
    TypeFromJSON,
    TypeToJSON,
} from '../models/index';

export interface CreateProjectApiV1ProjectsProjectPostRequest {
    projectCreateModel: ProjectCreateModel;
}

export interface DeleteProjectApiV1ProjectsProjectDeleteRequest {
    id: string;
}

export interface GetProjectAdminApiV1ProjectsProjectAdminGetRequest {
    id: string;
}

export interface GetProjectApiV1ProjectsProjectGetRequest {
    id: string;
}

export interface GetProjectsAdminApiV1ProjectsAdminGetRequest {
    limit?: number;
    offset?: number;
}

export interface GetProjectsApiV1ProjectsGetRequest {
    type?: Type;
    search?: Search;
    limit?: number;
    offset?: number;
}

export interface PublishProjectApiV1ProjectsProjectPublishPostRequest {
    id: string;
}

export interface UnpublishProjectApiV1ProjectsProjectUnpublishPostRequest {
    id: string;
}

export interface UpdateProjectApiV1ProjectsProjectPutRequest {
    id: string;
    projectUpdateModel: ProjectUpdateModel;
}

/**
 *
 */
export class ProjectsApi extends runtime.BaseAPI {
    /**
     * Create project
     * Create Project
     */
    async createProjectApiV1ProjectsProjectPostRaw(
        requestParameters: CreateProjectApiV1ProjectsProjectPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProjectModel>> {
        if (requestParameters['projectCreateModel'] == null) {
            throw new runtime.RequiredError(
                'projectCreateModel',
                'Required parameter "projectCreateModel" was null or undefined when calling createProjectApiV1ProjectsProjectPost().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectCreateModelToJSON(requestParameters['projectCreateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProjectModelFromJSON(jsonValue),
        );
    }

    /**
     * Create project
     * Create Project
     */
    async createProjectApiV1ProjectsProjectPost(
        requestParameters: CreateProjectApiV1ProjectsProjectPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProjectModel> {
        const response = await this.createProjectApiV1ProjectsProjectPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Delete project
     * Delete Project
     */
    async deleteProjectApiV1ProjectsProjectDeleteRaw(
        requestParameters: DeleteProjectApiV1ProjectsProjectDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteProjectApiV1ProjectsProjectDelete().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Delete project
     * Delete Project
     */
    async deleteProjectApiV1ProjectsProjectDelete(
        requestParameters: DeleteProjectApiV1ProjectsProjectDeleteRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<any> {
        const response = await this.deleteProjectApiV1ProjectsProjectDeleteRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get project by id - admin route
     * Get Project Admin
     */
    async getProjectAdminApiV1ProjectsProjectAdminGetRaw(
        requestParameters: GetProjectAdminApiV1ProjectsProjectAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProjectAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectAdminApiV1ProjectsProjectAdminGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProjectAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Get project by id - admin route
     * Get Project Admin
     */
    async getProjectAdminApiV1ProjectsProjectAdminGet(
        requestParameters: GetProjectAdminApiV1ProjectsProjectAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProjectAdminModel> {
        const response = await this.getProjectAdminApiV1ProjectsProjectAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get project by id
     * Get Project
     */
    async getProjectApiV1ProjectsProjectGetRaw(
        requestParameters: GetProjectApiV1ProjectsProjectGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ResponseGetProjectApiV1ProjectsProjectGet>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProjectApiV1ProjectsProjectGet().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/projects/project`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ResponseGetProjectApiV1ProjectsProjectGetFromJSON(jsonValue),
        );
    }

    /**
     * Get project by id
     * Get Project
     */
    async getProjectApiV1ProjectsProjectGet(
        requestParameters: GetProjectApiV1ProjectsProjectGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ResponseGetProjectApiV1ProjectsProjectGet> {
        const response = await this.getProjectApiV1ProjectsProjectGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get projects - admin route
     * Get Projects Admin
     */
    async getProjectsAdminApiV1ProjectsAdminGetRaw(
        requestParameters: GetProjectsAdminApiV1ProjectsAdminGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListProjectAdminResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/admin`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListProjectAdminResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get projects - admin route
     * Get Projects Admin
     */
    async getProjectsAdminApiV1ProjectsAdminGet(
        requestParameters: GetProjectsAdminApiV1ProjectsAdminGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListProjectAdminResponse> {
        const response = await this.getProjectsAdminApiV1ProjectsAdminGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get projects - public route
     * Get Projects
     */
    async getProjectsApiV1ProjectsGetRaw(
        requestParameters: GetProjectsApiV1ProjectsGetRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ListProjectResponse>> {
        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request(
            {
                path: `/api/v1/projects/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ListProjectResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get projects - public route
     * Get Projects
     */
    async getProjectsApiV1ProjectsGet(
        requestParameters: GetProjectsApiV1ProjectsGetRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ListProjectResponse> {
        const response = await this.getProjectsApiV1ProjectsGetRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Publish project
     * Publish Project
     */
    async publishProjectApiV1ProjectsProjectPublishPostRaw(
        requestParameters: PublishProjectApiV1ProjectsProjectPublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProjectAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publishProjectApiV1ProjectsProjectPublishPost().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project/publish`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProjectAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Publish project
     * Publish Project
     */
    async publishProjectApiV1ProjectsProjectPublishPost(
        requestParameters: PublishProjectApiV1ProjectsProjectPublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProjectAdminModel> {
        const response = await this.publishProjectApiV1ProjectsProjectPublishPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Unpublish project
     * Unpublish Project
     */
    async unpublishProjectApiV1ProjectsProjectUnpublishPostRaw(
        requestParameters: UnpublishProjectApiV1ProjectsProjectUnpublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProjectAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling unpublishProjectApiV1ProjectsProjectUnpublishPost().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project/unpublish`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProjectAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Unpublish project
     * Unpublish Project
     */
    async unpublishProjectApiV1ProjectsProjectUnpublishPost(
        requestParameters: UnpublishProjectApiV1ProjectsProjectUnpublishPostRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProjectAdminModel> {
        const response = await this.unpublishProjectApiV1ProjectsProjectUnpublishPostRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Update project
     * Update Project
     */
    async updateProjectApiV1ProjectsProjectPutRaw(
        requestParameters: UpdateProjectApiV1ProjectsProjectPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ProjectAdminModel>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateProjectApiV1ProjectsProjectPut().',
            );
        }

        if (requestParameters['projectUpdateModel'] == null) {
            throw new runtime.RequiredError(
                'projectUpdateModel',
                'Required parameter "projectUpdateModel" was null or undefined when calling updateProjectApiV1ProjectsProjectPut().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/projects/project`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectUpdateModelToJSON(requestParameters['projectUpdateModel']),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ProjectAdminModelFromJSON(jsonValue),
        );
    }

    /**
     * Update project
     * Update Project
     */
    async updateProjectApiV1ProjectsProjectPut(
        requestParameters: UpdateProjectApiV1ProjectsProjectPutRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ProjectAdminModel> {
        const response = await this.updateProjectApiV1ProjectsProjectPutRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
